import React from 'react';
import SVGLoader from './SVGLoader';

export default ({ width, height, viewboxWidth, viewboxHeight, ...rest }) => {
  return (
    <SVGLoader
      {...rest}
      width={width || 13}
      height={height || 15}
      viewboxWidth={viewboxWidth || 13}
      viewboxHeight={viewboxHeight || 15}
    >
      <path
        d="M12.436 3.54499C12.7266 3.34322 12.7851 2.93733 12.5634 2.66169L11.7534 1.65505C11.5708 1.42808 11.2504 1.36726 10.9973 1.51152C10.4348 1.87239 9.78733 2.07912 9.11976 2.11102C8.36654 2.11102 7.63968 1.77504 6.89964 1.0855C6.67463 0.875338 6.3253 0.875338 6.1003 1.0855C5.36026 1.77504 4.63339 2.11102 3.88017 2.11102C3.21244 2.08005 2.56474 1.87324 2.00262 1.51152C1.74953 1.36726 1.42914 1.42808 1.24652 1.65505L0.357203 2.76034C0.168924 2.99435 0.187184 3.33262 0.39956 3.54499C0.753315 3.89125 1.04981 4.29151 1.27795 4.73082C1.51277 5.19146 1.64119 5.69894 1.65374 6.21584C1.66628 6.73273 1.56262 7.24585 1.35042 7.71734C0.966121 8.62208 0.548886 9.95723 1.35042 11.075C1.93454 11.8831 3.03912 12.4277 4.20518 12.9613C4.8828 13.2288 5.52691 13.5745 6.12446 13.9912C6.33837 14.1641 6.644 14.1641 6.85791 13.9912C7.44853 13.5722 8.08692 13.225 8.75962 12.9569C9.93666 12.4233 11.0434 11.8765 11.6254 11.0684C12.4335 9.95064 12.0162 8.61769 11.6254 7.71075C11.4167 7.23859 11.3162 6.72573 11.3314 6.20973C11.3466 5.69374 11.4771 5.18767 11.7132 4.72862C11.9451 4.29005 12.0801 3.89064 12.436 3.54499Z"
        fill="#0B1928"
      />
    </SVGLoader>
  );
};
